module.exports = "/images/41632692389d996f78518a2ce369dad7.png";